import { endpoints, apiVersion } from "./endpoints";
import apiRequest from "./apiConfig";

export function getAllShiftsApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceShiftMapping,
    query
  })
}

export function getAllAttendanceShiftsApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + endpoints.attendance,
    query,
    responseType: query?.downloadFile ? "arraybuffer" : "json",
  })
}

export function editShiftDataApi(query, shiftId) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceShiftMapping + `/${shiftId}`,
    method: "put",
    query
  })
}

export function editAttedanceShiftApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + endpoints.attendance,
    method: "put",
    query
  })
}

export function addNewShiftApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceShiftMapping,
    method: 'post',
    query
  })
}